import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import { RootState, PartnerState, RewardShop } from '@/definitions'
import { AxiosResponse } from 'axios'
import axios from '@/plugins/axios'
import dayjs from 'dayjs'

const state: PartnerState = {
  shops: [],
  selectedShop: null
}

const getters: GetterTree<PartnerState, unknown> = {
  shops: (state): RewardShop[] => state.shops,
  selectedShop: (state): RewardShop | null => state.selectedShop
}

const mutations: MutationTree<PartnerState> = {
  setShops (state, shops: RewardShop[]): void {
    state.shops = shops
  },
  setSelectedShops (state, shop: RewardShop | null): void {
    state.selectedShop = shop
  }
}

const actions: ActionTree<PartnerState, RootState> = {
  async fetchShops ({ commit, rootGetters }): Promise<void> {
    const userId = rootGetters['user/currentUser'].id
    const shopRes: AxiosResponse = await axios.get(`/portal/users/${userId}/reward-shops`)
    const shops: RewardShop[] = shopRes.data.data
      .filter((item: any) => item.active_at !== null)
      .map((item: any) => {
        return {
          id: item.id,
          name: item.name,
          createdAt: dayjs(item.created_at),
          activeAt: dayjs(item.active_at),
          rewards: item.rewards
        }
      })
    commit('setShops', shops)
  },
  setSelectedShops ({ commit }, shop: RewardShop | null): void {
    commit('setSelectedShops', shop)
  }
}

export const partner: Module<PartnerState, RootState> = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
